<template>
  <router-view />
</template>

<script>

import { debounce } from "lodash";
    
    const _ = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ {
      constructor(callback) {
        callback = debounce(callback, 100);
        super(callback);
      }
    };
export default {
  name: 'App'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
.ql-container.ql-snow, 
.ql-toolbar.ql-snow, 
.quill-editor.ql-snow {
  border: none !important;
}

</style>
